const selectSourceType = ['DICTIONARY', 'IMG_UPLOAD', 'DATETIME', 'DATE']

export function createRules(paramList) {
  const rules = {}
  paramList.forEach((item) => {
    if (item.requiredStatus && item.showStatus) {
      const message = selectSourceType.indexOf(item.sourceType) > -1 ? '选择' : '输入'
      rules[item.fieldKey] = [{ required: true, message: `请${message}${item.fieldName}`, trigger: 'blur' }]
    }
  })
  return rules
}

export function splitArr(baseArray, n = 2) {
  baseArray.forEach(item => {
    if (item.fieldType === 'PROJECT_AUTH') {
      item.showStatus = false
    }
  })
  const len = baseArray.length
  const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1)
  const res = []
  for (let i = 0; i < lineNum; i++) {
    // slice() 方法返回一个从开始到结束（不包括结束）选择的数组的一部分浅拷贝到一个新数组对象。且原始数组不会被修改。
    const temp = baseArray.slice(i * n, i * n + n)
    res.push(temp)
  }
  return res
}

export function dispatch(componentName, eventName, params) {
  let parent = this.$parent || this.$root
  let name = parent.$options.componentName
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent
    if (parent) {
      name = parent.$options.componentName
    }
  }
  if (parent) {
    parent.$emit.apply(parent, [eventName].concat(params))
  }
}
